"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemDesc = exports.getItemName = exports.getGroupName = exports.drop = exports.transferToInventory = exports.pickupItem = exports.drawAll = exports.getAt = exports.setPos = exports.kill = exports.killAllButInPlayerInventory = exports.killAll = exports.create = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var common_sidecar_1 = require("../../../main/common-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueSpellData_sidecar_1 = require("../anims/rogueSpellData-sidecar");
var rogueInput_1 = require("../input/rogueInput");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonofont_1 = require("../monofont/rogueMonofont");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueMonstersAi_1 = require("../monsters/rogueMonstersAi");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueItems_sidecar_1 = require("./rogueItems-sidecar");
var rogueItemsData_1 = require("./rogueItemsData");
var rogueItemsData_sidecar_1 = require("./rogueItemsData-sidecar");
var rogueItemsData_potions_sidecar_1 = require("./rogueItemsData_potions-sidecar");
var _objs = [];
var getAll = function () {
    return _objs;
};
exports.getAll = getAll;
var create = function (type) {
    var data = rogueItemsData_sidecar_1.rogueItemsData.get(type);
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().items, data.sprite[0]);
    image.scale = rogueDef_sidecar_1.rogueDef.scale;
    var image2 = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().items, data.sprite2 ? data.sprite2[0] : data.sprite[0]);
    image2.scale = rogueDef_sidecar_1.rogueDef.scale;
    image2.visible = data.sprite2 ? true : false;
    image.tint = data.color;
    image2.tint = data.color;
    var variant = null;
    if (data.group === rogueItemsData_sidecar_1.rogueItemsData.ERogueItemGroup.potion) {
        variant = rogueItemsData_potions_sidecar_1.rogueItemsData_potions.findPotionVariantComboByType(data.type);
        image.tint = variant.variant.color;
    }
    var c = {
        x: 0,
        y: 0,
        char: data.char,
        frames: data.sprite,
        image: image,
        image2: image2,
        isDead: false,
        data: data,
        variant: variant,
        amount: 1,
        isInInventory: false,
    };
    _objs.push(c);
    return c;
};
exports.create = create;
var killAll = function () {
    _objs.forEach(function (c) {
        (0, exports.kill)(c); // TODO: what if in inventory?
    });
    cleanup();
};
exports.killAll = killAll;
var killAllButInPlayerInventory = function () {
    _objs.forEach(function (c) {
        if (!c.isInInventory) {
            (0, exports.kill)(c);
        }
    });
    cleanup();
};
exports.killAllButInPlayerInventory = killAllButInPlayerInventory;
var cleanup = function () {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(_objs, function (c) {
        c.image.destroy();
        c.image2.destroy();
    });
};
var kill = function (c) {
    c.isDead = true;
    c.image.visible = false;
    c.image2.visible = false;
};
exports.kill = kill;
var setPos = function (c, x, y) {
    c.x = x;
    c.y = y;
};
exports.setPos = setPos;
var getAt = function (x, y) {
    return _objs.find(function (c) { return !c.isInInventory && c.x === x && c.y === y; }) || null;
};
exports.getAt = getAt;
var _rainbowTimer = 0;
var drawAll = function () {
    // let game = game2.getGame()
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    var isDoneWithLevel = rogueStats_sidecar_1.rogueStats.countPetsLeft() === 0;
    _rainbowTimer -= common_sidecar_1.common.getUpdateDelta();
    var rainbowAdvance = false;
    if (_rainbowTimer <= 0) {
        rainbowAdvance = true;
        _rainbowTimer = 0.15;
    }
    _objs.forEach(function (c) {
        if (c.data.isBurnable) {
            if ((0, rogueMonstersAi_1.isNextTo4)(map, c.x, c.y, function (t) {
                var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(t.x, t.y);
                if (m && m.data.isFire) {
                    return true;
                }
                return false;
            })) {
                (0, exports.kill)(c);
                var newItem = (0, exports.create)('ex-item');
                (0, exports.setPos)(newItem, c.x, c.y);
            }
        }
    });
    cleanup();
    var useAscii = rogueStats_sidecar_1.rogueStats.useAscii();
    _objs.forEach(function (c) {
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image, c);
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image2, c);
        if (c.data.group === rogueItemsData_1.ERogueItemGroup.rift) {
            if (isDoneWithLevel) {
                if (rainbowAdvance) {
                    c.image.tint = rando_sidecar_1.rando.sample(rogueMonofont_1.riftScale);
                }
            }
            else {
                c.image.tint = rogueDef_sidecar_1.rogueDef.colors.dark;
            }
        }
        if (useAscii) {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, rogueMonofont_sidecar_1.rogueMonofont.getSprite(c.data.char)[0]);
        }
        else {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, c.data.sprite[0]);
        }
        if (c.isInInventory) {
            c.image.visible = false;
            c.image2.visible = false;
        }
        else {
            var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, c.x, c.y);
            if (t) {
                if (t.eVision === rogueMaps_1.EVision.None) {
                    c.image.visible = false;
                    c.image2.visible = false;
                }
                else {
                    c.image.visible = true;
                    if (c.data.sprite2) {
                        c.image2.visible = true;
                    }
                    else {
                        c.image2.visible = false;
                    }
                }
            }
        }
    });
};
exports.drawAll = drawAll;
var pickupItem = function (c, item) {
    if (item.data.group === rogueItemsData_1.ERogueItemGroup.rift) {
        console.log('through rift!');
        // rogueRunner.nextLevel()
        if (rogueStats_sidecar_1.rogueStats.getStats().depth >= 10) {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openWinScreen);
        }
        else {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openLevelSelect);
        }
    }
    if (item.data.group === rogueItemsData_sidecar_1.rogueItemsData.ERogueItemGroup.upgrade) {
        rogueStats_sidecar_1.rogueStats.setMessage('You gain a skill point!');
        rogueStats_sidecar_1.rogueStats.addSkillPoint();
        rogueItems_sidecar_1.rogueItems.kill(item);
    }
    if (item.data.group === rogueItemsData_sidecar_1.rogueItemsData.ERogueItemGroup.furniture) {
        if (item.data.type === 'toilet') {
            rogueStats_sidecar_1.rogueStats.setMessage('All spells refreshed from the water!');
            rogueSpellData_sidecar_1.rogueSpellData.refreshAllSpells();
            rogueItems_sidecar_1.rogueItems.kill(item);
        }
    }
    if (item.data.group === rogueItemsData_sidecar_1.rogueItemsData.ERogueItemGroup.gold) {
        // todo do something with item
        rogueStats_sidecar_1.rogueStats.addGold(item.amount);
        rogueStats_sidecar_1.rogueStats.setMessage("You picked up ".concat(item.amount, " gold."));
        rogueItems_sidecar_1.rogueItems.kill(item);
    }
    if (item.data.group === rogueItemsData_sidecar_1.rogueItemsData.ERogueItemGroup.weapon) {
        rogueStats_sidecar_1.rogueStats.setMessage("You picked up the ".concat(item.data.name, "."));
        (0, exports.transferToInventory)(c, item);
    }
    if (item.data.group === rogueItemsData_sidecar_1.rogueItemsData.ERogueItemGroup.potion) {
        assert_sidecar_1.assert.notNil(item.variant, 'item.variant');
        rogueStats_sidecar_1.rogueStats.setMessage("You pick up a ".concat((0, exports.getItemName)(item), "."));
        (0, exports.transferToInventory)(c, item);
    }
    if (item.data.group === rogueItemsData_sidecar_1.rogueItemsData.ERogueItemGroup.scroll) {
        // assert.notNil(item.variant, 'item.variant')
        rogueStats_sidecar_1.rogueStats.setMessage("You pick up a ".concat((0, exports.getItemName)(item), "."));
        (0, exports.transferToInventory)(c, item);
    }
};
exports.pickupItem = pickupItem;
var transferToInventory = function (c, item) {
    assert_sidecar_1.assert.f(item.isInInventory);
    assert_sidecar_1.assert.notIn(c.inventory, item, 'item');
    rogueItems_sidecar_1.rogueItems.setPos(item, -1, -1);
    item.isInInventory = true;
    c.inventory.push(item);
};
exports.transferToInventory = transferToInventory;
var drop = function (c, item) {
    assert_sidecar_1.assert.t(item.isInInventory);
    assert_sidecar_1.assert.isIn(c.inventory, item, 'item');
    rogueItems_sidecar_1.rogueItems.setPos(item, c.x, c.y);
    rogueMonsters_sidecar_1.rogueMonsters.removeFromInventory(c, item);
};
exports.drop = drop;
var getGroupName = function (item) {
    if (item.data.group === rogueItemsData_1.ERogueItemGroup.potion) {
        return 'potion';
    }
    if (item.data.group === rogueItemsData_1.ERogueItemGroup.gold) {
        return 'gold';
    }
    if (item.data.group === rogueItemsData_1.ERogueItemGroup.scroll) {
        return 'scroll';
    }
    return '?';
};
exports.getGroupName = getGroupName;
var getItemName = function (item) {
    if (item.variant) {
        if (item.variant.isIdentified) {
            return item.data.name;
        }
        else {
            return item.variant.variant.name + ' ' + (0, exports.getGroupName)(item);
        }
    }
    return item.data.name;
};
exports.getItemName = getItemName;
var getItemDesc = function (item) {
    if (item.variant) {
        if (item.variant.isIdentified) {
            return item.data.description;
        }
        else {
            return '???';
        }
    }
    return item.data.description;
};
exports.getItemDesc = getItemDesc;
